import { render, staticRenderFns } from "./ModalNewType.vue?vue&type=template&id=316aa978&scoped=true&"
import script from "./ModalNewType.vue?vue&type=script&lang=js&"
export * from "./ModalNewType.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewType.vue?vue&type=style&index=0&id=316aa978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316aa978",
  null
  
)

export default component.exports